<template lang="pug">
  .block-prizes
    h2.block-prizes__title {{ getText('title') }}
    .block-prizes__separator

    template(v-if="user === 'not_authed'")
      .block-prizes__text {{ getText('text') }}
      .block-prizes__prizes.block-prizes__prizes--1
        .block-prizes__prize.block-prizes__prize--spotlight(@click="handleClick")
          img(:src="getImageSrc('chest.png')")
      .block-prizes__note {{ getText('note') }}

    template(v-else)
      .block-prizes__text {{ getText('text') }}
      .block-prizes__prizes(:class="getPrizesCountClass")
        .block-prizes__prize.block-prizes__prize--frame(v-for="(item, index) in getText('list')", :key="index")
          a(v-if="item.link", :href="item.link")
            img(:src="getImageSrc(`${user}/${index}.png`)")
          img(v-else, :src="getImageSrc(`${user}/${index}.png`)")

          .controller-info.block-prizes__info(:name="`tippy_${index}`") !

          template(v-if="user === 'old'")
            tippy(:delay="[400,0]" :to="`tippy_${index}`", theme="la", arrow="true", flip="true", interactive="false", placement="right-center")
              ItemTooltip(:item="item")

          template(v-else)
            tippy(:to="`tippy_${index}`", theme="white", arrow="true", interactive="true")
              .tooltip
                p.tippy-text(v-html="item.text")

</template>

<script>
import ItemTooltip from "./ItemTooltip";

export default {
  name: "BlockPrizes",
  components: { ItemTooltip },
  props: {
    user: {
      type: String,
      required: true,
    },
  },

  computed: {
    getPrizesCountClass() {
      return `block-prizes__prizes--${Object.keys(this.getText("list")).length}`;
    },
  },

  methods: {
    getText(param) {
      return this.$t(`promo.prizes.${this.user}.${param}`);
    },
    getImageSrc(img) {
      return require(`@/assets/images/prizes/${img}`);
    },
    handleClick() {
      this.$emit("prizeClick");
    },
  },
};
</script>
